import styled from "styled-components";

export const ReferWalk = styled.div`
    position: relative;
    &.active{
        pointer-events: none;
        z-index: 999;
    }
`
export const ReferButton = styled.button`
    display: flex;
    padding: 0.8rem 1.7rem;
    align-items: center;
    color: #2C55A0;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 0;
    border-radius: 0.8rem;
    border: 0.06rem solid #2C55A0;
    background: #FFF;
    position: fixed;
    top: 10rem;
    right: 4rem;
    z-index: 2;
    gap: 1.6rem;
    transition:0.25s ease-in;
    @media(max-width: 740px){
        top: 15.5rem;
        left: 2rem;
        right: auto;
    }
    &:hover{
        background:#E7EBF8;
    }
    i{
        display: inline-block;
        width: 2.8rem;
        height: 3.2rem;
        svg{
            height: 100%;
            width: 100%;
        }
    }
`
export const MainPopupWrapper =  styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    height:100%;
    width:100%;
`
export const CloseBtn = styled.button`
     position:absolute;
     top:2rem;
     right:2rem;
`;

export const MainPopupBothSectionWraper =  styled.div`
    width:98.8rem;
    background:#fff;
    border-radius:1.6rem;
    display:flex;
    overflow:hidden;
    height: calc(100vh - 6rem);
    position: relative;
    @media(max-width: 768px){
        flex-wrap: wrap;
        overflow: auto;
        width: calc(100% - 30px);
        max-width:400px;
        position:static;
    }
    @media (min-height:700px){
        height:68rem;
    }

    .close-icon-div{
        position: absolute;
        padding:0.8rem 1.8rem;
        display:flex;
        justify-content:flex-end;
        background:transparent;
        z-index:1;
        width:100%;
        @media(max-width:768px){
            max-width:400px;
            left:50%;
            transform:translateX(-50%);
        }

        @media(max-width:430px){
            max-width:calc(100% - 30px);
        }
        &:after{
            content:'';
            position:absolute;
            width:50%;
            height:100%;
            background:#eff6ff;
            right:0;
            top:0;
            @media(max-width:768px){
                    width:100%;
                    background:#fff;
                    border-radius: 1.6rem 1.6rem 0rem 0rem;
            }
        }
    .close-icon{
        display: inline-block;
        height: 3rem;
        width: 3rem;
        z-index: 1;
        i{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
                height: 100%;
                width: 100%;
            }
        }
        @media(max-width: 768px){
            top: 30px;
            right: 30px;
            height: 40px;
            width: 40px;
        }
    }}
`
export const MainPopupBothSectionLeft = styled.div`
  width: 50%;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  overflow: auto;
  @media (max-width: 768px) {
    width: 100%;
    padding-top: 60px;
  }
  .popup-heading {
    color: #4d4d4f;
    font-size: 3.8rem;
    font-weight: 700;
    line-height: 4.94rem;
    border-bottom: 0.1rem solid #e6e6e6;
    padding-bottom: 1.4rem;
    @media (max-width: 768px) {
      font-size: 3rem;
      font-weight: 700;
      line-height: normal;
    }
    @media (max-width: 450px) {
      font-size: 2.5rem;
      font-weight: 700;
      line-height: normal;
    }
  }
  .popup-body {
    flex: 1;
    padding-top: 20px;
    color: rgba(77, 77, 79, 0.8);
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
    padding-bottom: 15px;

    b {
      font-weight: 600;
    }
    .send-invite-wrap {
      display: flex;
      align-items: center;
      gap: 3.2rem;
      margin-top: 1.6rem;
      .error-msg {
        color: #db324d;
        display: inline-block;
        font-size: 1.2rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0.046rem;
      }
    }
  }
  .popup-footer {
    border-radius: 0.8rem;
    border: 0.08rem solid #008c92;
    padding: 0.6rem;
    display: flex;
    gap: 1.6rem;
    align-items: center;
    color: #008c92;
    background-image: url("${require(`../../assets/img/ReferColleaguePopup/footer-bg.svg`)
      .default}");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    b {
      font-style: normal;
      font-size: 1.6rem;
    }
    .left-footer-svg {
      width: 9.92rem;
      color: #008c92;
      font-size: 1.2rem;
      font-weight: 400;
      svg {
        max-width: 100%;
      }
    }
  }
`;
export const EmailInput = styled.input`
     width:100%;
     padding:1.3rem 1rem; 
     border-radius: 0.4rem;
     border: 0.1rem solid #7D868C;
     margin-top:3rem;
     font-size: 1.6rem;
     font-weight: 400;
     outline:0;
     &::placeholder{
        color:#7D868C;
        font-weight: 400;
     }
`;
export const SendInviteBtn = styled.button`
    border-radius: 0.4rem;
    background:${({ disabled }) => disabled ? '#85C7E8' : ' #118ACB'};
    font-size: 1.6rem;
    font-weight: 500;
    color:#fff;
    padding:1.7rem 3.2rem;
    cursor:${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    @media(max-width:768px){
        font-size:12px;
        padding:10px 12px;
        white-space:nowrap;
    }
`;
export const InvitationSuccessPopup = styled.div`
        display:flex;
        align-items:center;
        justify-content:center;
        position:absolute;
        z-index:1;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: rgba(77, 77, 79, 0.30);
        transition:0.25s;
        opacity:${({ open }) => open ? '1' : '0'};
        visibility:${({ open }) => open ? '' : 'hidden'}

`;
export const InvitationSuccessRightPopup = styled.div`
      position:absolute;
      z-index:1;
      top:0;
      bottom:0;
      right:0;
      left:0;
      display:flex;
      justify-contents:center;
      align-items:center;
      background:transparent;
      padding:2.2rem;
      opacity:${({ open }) => open ? '1' : '0'};
      visibility:${({ open }) => open ? '' : 'hidden'}
`;
export const InvitationSuccessRightPopupCard = styled.div`
    width:100%;
    text-align:center;
    min-height:25rem;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    border-radius: 6px;
    border: 0.2rem solid #D3E6FF;
    background:#FFF;
    box-shadow: 0px 0px 8px 0px rgba(21, 27, 38, 0.12);
p{
    max-width:27.8rem;
    font-size: 1.8rem;
    font-weight: 500;
}
img{
    max-width:8rem;
    margin-bottom:3rem;
}
`;
export const InvitationRemovePopup = styled.div`
        display:flex;
        align-items:center;
        justify-content:center;
        position:absolute;
        z-index:1;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: rgba(77, 77, 79, 0.30);
        transition:0.25s;
        opacity:${({ open }) => open ? '1' : '0'};
        visibility:${({ open }) => open ? '' : 'hidden'}

`;
export const InvitationRemoveRightPopup = styled.div`
      position:absolute;
      z-index:1;
      top:0;
      bottom:0;
      right:0;
      left:0;
      display:flex;
      justify-contents:center;
      align-items:center;
      background:transparent;
      padding:2.2rem;
      opacity:${({ open }) => open ? '1' : '0'};
      visibility:${({ open }) => open ? '' : 'hidden'}
`;
export const InvitationRemoveRightPopupCard = styled.div`
    width:100%;
    text-align:center;
    min-height:17.9rem;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    border-radius: 6px;
    border: 0.2rem solid #D3E6FF;
    background:#FFF;
    box-shadow: 0px 0px 8px 0px rgba(21, 27, 38, 0.12);
p{
    max-width:37rem;
    font-size: 1.6rem;
    font-weight: 500;
    line-height:150%;
}

`;

export const InvitationRemoveBtnWrapper = styled.div`
    display:flex;
    gap:1.6rem;
    margin-top:2.6rem;
    .cancel-btn{
        color: #4A4A4A;
        font-size: 1.5rem;
        font-weight: 500;
        border-radius: 0.4rem;
        border: 0.1rem solid #4A4A4A;
        padding:0.9rem 2.5rem;
    }
    .remove-btn{
        font-size: 1.5rem;
        font-weight: 500;
        border-radius: 0.4rem;
        border: 0.1rem  solid #DB324D;
        padding:0.9rem 2.5rem;
        background:rgba(219, 50, 77, 0.14);
        color:#DB324D;
    }
`;
export const InvitationSuccessCard = styled.div`
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        gap:1.2rem;
        border-radius: 1.6rem;
        border: 0.1rem solid #8CDCD2;
        background:  #FFF;
        width:24rem;
        padding:2.2rem;
        p{
            max-width:11.2rem;
            color:#0D2C54;
            font-size: 1.6rem;
            font-weight: 400;
            text-align:center;
        }
        .success-img{
            max-width:12rem;
        }
`;
// Right Section
export const MainPopupBothSectionRight =  styled.div`
    overflow-y:auto;
    width:50%;  
    padding-bottom:20px;
    border-radius: 0px 1.6rem 1.6rem 0;
    background: #EFF6FF;
    position: relative;
    @media(max-width: 768px){
        padding: 20px 15px;
        border-radius: 0;
        width: 100%;
        position:static;
    }
`
export const RightInviteContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5rem 2.1rem 4rem 2.1rem;
    height: 100%;
    position: relative;
`
export const RightInviteHead = styled.div`
    .invite-text{
        color: #4D4D4F;
        display: inline-block;
        font-size: 1.6rem;
        font-weight: 600;
        line-height: 2.4rem; /* 150% */
        margin-bottom: 2.8rem;
    }
`
export const RightInviteBody = styled.div`
    flex: 1;
`
export const NoInviteUserWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    i{
        display: block;
        max-width: 287px;
        svg{
            height: 100%;
            width: 100%;
        }
    }
`
export const RightInviteUserWrap = styled.div``
export const RightInviteList = styled.div``
export const RightInviteListItem = styled.div`
    display: flex;
    align-items: center;
    gap: 1.2rem;
    margin-bottom: 1.1rem;
`
export const RightEmailBox = styled.div`
    border-radius: 0.4rem;
    border: 0.1rem solid #F0F0F0;
    background: #FFF;
    padding: 0.8rem 1.2rem;
    display: flex;
    gap: 1.2rem;
    width: calc(100% - 2.9rem);
    flex: 1;
    @media(max-width:768px){
        min-width: calc(100% - 2.9rem);
    }
    .email{
        color: #4D4D4F;
        font-size: 1.4rem;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-weight: 400;
        line-height: 2.4rem; 
        width: calc(100% - 6.6rem);
    }
    button{
        display: inline-block;
        position: relative;
        height: 2.2rem;
        width: 2.2rem;
        i{
            display: inline-block;
            height: 100%;
            width: 100%;
            svg{
                height: 100%;
                width: 100%;
            }
        }
        .email-tooltip{
            position: absolute;
            font-family: Roboto;
            font-size: 1.4rem;
            font-weight: 400;
            line-height: 2rem; 
            letter-spacing: 0.015rem;
            padding: 0.8rem 1.6rem;
            border-radius: 0.4rem;
            width: max-content;
            bottom: 2.5rem;
            right: 1.2rem;
            display: none;
        }
        &.send-btn{
            .email-tooltip{
                background: #E5F2E5;
                color: #43A047;
            }
            &:hover{
                svg{
                    path{
                        stroke: #43A047;
                    }
                }
                .email-tooltip{
                    display: block;
                }
            }
        }
        &.remove-btn{
            .email-tooltip{
                background: #FAE2E6;
                color: #DB324D;
            }
            &:hover{
                svg{
                    path{
                        stroke: #DB324D;
                    }
                    circle{
                        stroke: #DB324D;
                    }
                }
                .email-tooltip{
                    display: block;
                }
            }
        }
    }
`
export const LeftCount = styled.span`
    color: #4D4D4F;
    font-size: 1.6rem;
    font-weight: 500;
    display: inline-flex;
    justify-content: flex-end;
    line-height: 2.4rem;
    min-width: 2.9rem;
`
export const InvitedUserWrap = styled.div`
    margin-bottom: 3.4rem;
`
export const RegisteredUserWrap = styled.div`
    margin-bottom: 3.4rem;  
    ${RightEmailBox}{
        .email{
            width: 100%;
        }
    }
`
export const UnRegisteredUserWrap = styled.div``